<template>
    <div class="af" >
        <div class="flex alc" id="toolH">
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" placeholder="请输入人名搜索" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                height="385"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @selection-change="handleSelectionChange"

                :row-key="getRowKeys"
        >
            <!--row-key="vc_no"  @select="select"
                @select-all="selectAll"-->
            <el-table-column align="center" type="selection" :selectable="isRowSelectable" :reserve-selection="true">
            </el-table-column>
            <el-table-column align="center" type="index" label="" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="vc_name" label="姓名" show-overflow-tooltip>
            </el-table-column>
        </el-table>
        <div v-for="(item,index) in showinList" style="display: inline-block;padding: 5px 10px;border: 1px solid #8e8e8e;margin-right: 15px">
            {{item.vc_name}}
            <i class="el-icon-close" style="color: red;margin-left: 5px" @click="deleteFun(item,index)"></i>
        </div>
        <el-pagination
                class="mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[15, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button type="primary" @click="saveForm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">取 消</el-button>
        </div>
    </div>
</template>
<script>
    import * as API from "../api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {
        },
        props: {
            dataOrd: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                loading:false,
                vc_search:"",
                getRowKeys(row){
                    return row.i_id
                },
                baseerp: "",
                mid: 0,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                showinList:[],
                pageSize: 30,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("dataOrd", this.dataOrd);
            this.getOrders();
            this.baseerp = baseerp;
        },
        methods: {
            gosearch(){
                /*this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];*/
                this.currentPage=1;
                this.tableData=[];
                this.getOrders();
            },
            /*changeData(e,type){
                if(type=='iover'){
                    this.i_over=e;
                    this.tableData.map((item,index)=>{
                        this.$refs.table.toggleRowSelection(this.tableData[index],false)
                    })
                    this.multipleSelection=[];
                    this.refreshTable();
                    //刷新列表
                }
                this.getOrders();
            },*/

            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            isRowSelectable(row,index){
               if(row.disabled){
                   return false
               }else{
                   return true
               }
            },
            selectAll(val){
                //console.log(val,'quanxuan')
                this.multipleSelection = val;
                this.showinList = val;
            },
            select(val,row){
                const  added=[...val].filter(item=>[...this.multipleSelection].every(y=>y.i_id!=item.i_id));
                const  removeed=[...this.multipleSelection].filter(item=>[...val].every(y=>y.i_id!=item.i_id));
                //console.log(added,'add',removeed)
                if(val.length>this.multipleSelection.length){
                    let val=added;
                    // console.log('a++++')
                    this.showinList.push(...added)
                }else{
                    this.showinList=this.showinList.filter(item=>item.i_id!==removeed[0].i_id)
                }
                this.multipleSelection=[];
                this.multipleSelection=val;
                // console.log(this.showinList,'this.showinList')
            },

            deleteFun(val,i){
                this.$refs.table.toggleRowSelection(this.tableData.find(item=>item.i_id==val.i_id),false)
                this.showinList=this.showinList.filter(item=>item.i_id!==val.i_id)
                this.multipleSelection=this.multipleSelection.filter(item=>item.i_id!==val.i_id);
            },
            handleSelectionChange(val) {
                //console.log(val,'val')
                const  added=[...val].filter(item=>[...this.multipleSelection].every(y=>y.i_id!=item.i_id));
                const  removeed=[...this.multipleSelection].filter(item=>[...val].every(y=>y.i_id!=item.i_id));
                //console.log(added,'add',removeed)
                if(val.length>this.multipleSelection.length){
                    let val=added;
                    //console.log('a++++')
                    this.showinList.push(...added)
                }else{
                    //console.log(this.showinList,"??????",removeed)
                    //this.showinList=this.showinList.filter(item=>item.i_id!==removeed[0].i_id)
                    removeed.map(reitem=>{
                        this.showinList=this.showinList.filter(item=>item.i_id!==reitem.i_id)
                    })
                }
                this.multipleSelection=[];
                this.multipleSelection=val;
                //console.log(this.showinList,'this.showinList')
            },
            //订单列表
            async getOrders(){
                /*this.tableData= [
                    {i_id:1,vc_name:'张三'},
                    {i_id:2,vc_name:'李四'}
                ],
                this.$nextTick(()=>{
                    for(let i=0;i<this.tableData.length;i++){
                        let pz= this.tableData[i];
                        for(let s of this.dataOrd.choo){
                            if(pz.i_id==s.i_id){
                                this.$refs.table.toggleRowSelection(this.tableData[i],true)
                            }
                        }

                    }

                });
                return;*/
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    'vc_search':this.vc_search,
                };
                let res = await API.bmuids(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data.list;
                    this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(()=>{
                        for(let i=0;i<this.tableData.length;i++){
                            let pz= this.tableData[i];
                            for(let s of this.dataOrd.choo){
                                if(pz.i_id==s.i_id){
                                    this.$refs.table.toggleRowSelection(this.tableData[i],true)
                                }
                            }

                        }

                    });

                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                /*this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })*/
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders();
            },
            handleCurrentChange(val){
                /*this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })*/
                this.currentPage=val;
                this.getOrders();
            },
            /*//获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders();
            },*/

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            //保存
            async saveForm(){
                //console.log('this.multipleSelection',this.multipleSelection)
                if(this.multipleSelection.length==0&&this.dataOrd.choo.length==0){
                    this.$message.error('请选择接收人！');
                    return;
                }
                let map={
                    multipleSelection:this.multipleSelection,
                }
                this.$emit('cancelDialog',map)
            },
            cancel(){
                this.$emit('cancelDialog');
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>

    /deep/ .el-table th{
            //text-align: left !important;
        }

    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
